<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      坪山围站<br>
站点介绍
坪山围站位于坪山大道与深汕公路交叉口处，14号线部分沿坪山大道南北方向布置，16号线坪山围站位于深汕公路西侧坪山围地块内。主体呈东西走向，车站东北侧临近益田假日世界，西北侧临近坪山公园，南侧临近深城投中城花园。车站为地下三层结构，地下一层为站厅层，地下二层、地下三层为站台层，站台形式重叠岛式站台<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:13	23:11	14号线	4分30秒	6分15秒<br>
沙田	06:43	00:13	14号线	4分30秒	6分15秒<br>
大运	06:25	23:34	16号线	5分32秒	6分48秒<br>
田心	05:59	23:14	16号线	5分32秒	6分48秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:11	23:11	14号线	5分25秒	6分15秒<br>
沙田	06:43	00:13	14号线	5分25秒	6分15秒<br>
大运	06:34	23:34	16号线	5分50秒	6分钟-9分钟<br>
田心	06:05	23:14	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:11	00:11	14号线	5分钟	6分15秒<br>
沙田	06:43	01:13	14号线	5分钟	6分15秒<br>
大运	06:34	00:34	16号线	5分50秒	6分钟-9分钟<br>
田心	06:05	00:14	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
坪山公园<br><br>
B出入口:<br>
坪山街道办事处<br><br>
C出入口:<br>
深城投中城花园<br><br>
D出入口:<br>
E1、E2、F、G<br><br>
H出入口:<br>
坪山六联小学<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坪山大道东纵路口<br>
366，833，E20，M277，M295，M325，M326，M439，M546高峰专向8，高峰专线64<br><br>
B出入口:<br>
公交站名： 坪山电子城①<br>
963，978，E22，E34，M136，M361，高峰专向8，深惠3A<br><br>
B出入口:<br>
公交站名： 坪山电子城②<br>
366，833，915，b760，e20，m295，m326，m434，m439，m443，m479，m575，m576，高峰专线64<br><br>
B出入口:<br>
公交站名： 坪山街道办<br>
b760，m575，m576<br><br>
H出入口:<br>
公交站名： 坪山围<br>
963，964,978，M136，M277，M296，M325，M361，M434，M443，M546，M564，深惠3A<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>